const CORE_CONTENT_RENDERED_EVENT = 'pli:core-content-rendered';

type IdleCallbackHandle = number;

type WindowWithIdleCallback = Window &
  typeof globalThis & {
    requestIdleCallback?: (
      callback: IdleRequestCallback,
      options?: IdleRequestOptions
    ) => IdleCallbackHandle;
    cancelIdleCallback?: (handle: IdleCallbackHandle) => void;
  };

const scheduleIdle = (callback: () => void, timeout: number) => {
  const win = window as WindowWithIdleCallback;

  if (win.requestIdleCallback) {
    const idleId = win.requestIdleCallback(callback, { timeout });
    return () => win.cancelIdleCallback?.(idleId);
  }

  const timeoutId = window.setTimeout(callback, timeout);
  return () => window.clearTimeout(timeoutId);
};

export const notifyCoreContentRendered = () => {
  window.dispatchEvent(new Event(CORE_CONTENT_RENDERED_EVENT));
};

export const runAfterCoreContent = (
  callback: () => void,
  { timeout = 5000, idleTimeout = 2000 } = {}
) => {
  let completed = false;
  let cancelIdle: (() => void) | undefined;

  const run = () => {
    if (completed) return;
    completed = true;
    window.removeEventListener(CORE_CONTENT_RENDERED_EVENT, run);
    window.clearTimeout(timeoutId);
    cancelIdle = scheduleIdle(callback, idleTimeout);
  };

  const timeoutId = window.setTimeout(run, timeout);
  window.addEventListener(CORE_CONTENT_RENDERED_EVENT, run, { once: true });

  return () => {
    completed = true;
    window.removeEventListener(CORE_CONTENT_RENDERED_EVENT, run);
    window.clearTimeout(timeoutId);
    cancelIdle?.();
  };
};
